const smartSchool = {
  // Header
  header: {
    title: 'Smart School System',
    backToWebsite: 'Main Website',
    admin: 'Admin',
    systemAdmin: 'System Administrator',
    logout: 'Logout',
  },

  // Sidebar
  sidebar: {
    logo: 'SAI College',
  },

  // Menu Items
  menu: {
    dashboard: 'Dashboard',

    studentInfo: {
      title: 'Student Information',
      details: 'Student Details',
      admission: 'Student Admission',
      onlineAdmission: 'Online Admission',
      disabled: 'Disabled Students',
      multiClass: 'Multi Class Student',
      bulkDelete: 'Bulk Delete',
      categories: 'Student Categories',
      house: 'Student House',
      disableReason: 'Disable Reason',
      cv: 'Student CV',
      studentDetails: 'Student Details',
      manageStudentProfiles: 'Manage Student Profiles',
      studentProfile: 'Student Profile',
      personalInfo: 'Personal Information',
      contactInfo: 'Contact Information',
      guardianInfo: 'Guardian Information',
      academicInfo: 'Academic Information',
    },

    fees: {
      title: 'Financial System',
      collection: 'Fees Collection',
      feeTypes: 'Fee Types',
      income: 'Income',
      expenses: 'Expenses',
      reports: 'Financial Reports',
    },

    onlineCourse: 'Online Course',
    behaviourRecords: 'Behaviour Records',
    multiBranch: 'Multi Branch',

    liveClasses: {
      title: 'Live Classes',
      gmeet: 'Google Meet',
      zoom: 'Zoom',
    },

    academics: {
      title: 'Academics',
      calendar: 'Annual Calendar',
      lessonPlan: 'Lesson Plan',
      subjects: 'Subjects',
      timetable: 'Timetable',
    },

    examinations: {
      title: 'Examinations',
      regular: 'Regular Examinations',
      cbse: 'CBSE Examination',
      online: 'Online Examinations',
    },

    attendance: 'Attendance',
    homework: 'Homework',

    hr: {
      title: 'Human Resource',
      employees: 'Employees',
      departments: 'Departments',
      leave: 'Leave Management',
      payroll: 'Payroll',
      attendance: 'Staff Attendance',
    },

    communicate: {
      title: 'Communicate',
      notice: 'Notice Board',
      email: 'Email',
      sms: 'SMS',
    },

    resources: {
      title: 'Resources',
      downloadCenter: 'Download Center',
      library: 'Library',
      inventory: 'Inventory',
    },

    transport: 'Transport',
    hostel: 'Hostel',
    certificate: 'Certificate',
    frontCMS: 'Front CMS',
    alumni: 'Alumni',
    reports: 'Reports',

    system: {
      title: 'System Settings',
      settings: 'General Settings',
      backup: 'Backup',
      roles: 'Roles & Permissions',
    },
  },

  // Dashboard
  dashboard: {
    title: 'Main Dashboard',
    subtitle: 'Comprehensive overview of Smart School System',

    stats: {
      totalStudents: 'Total Students',
      activeStudents: 'Active Students',
      newAdmissions: 'New Admissions',
      totalStaff: 'Total Staff',
      teachers: 'Teachers',
      adminStaff: 'Admin Staff',
      totalRevenue: 'Total Revenue',
      pendingFees: 'Pending Fees',
      collectionRate: 'Collection Rate',
      attendanceRate: 'Attendance Rate',
      todayPresent: 'Present Today',
      todayAbsent: 'Absent Today',
      upcomingExams: 'Upcoming Exams',
      completedExams: 'Completed Exams',
      avgScore: 'Average Score',
      totalClasses: 'Total Classes',
      activeCourses: 'Active Courses',
      totalSubjects: 'Total Subjects',
    },

    quickAccess: {
      title: 'Quick Access',
      studentAdmission: 'New Student Admission',
      markAttendance: 'Mark Attendance',
      collectFees: 'Collect Fees',
      createExam: 'Create Exam',
      assignHomework: 'Assign Homework',
      sendNotice: 'Send Notice',
      generateReport: 'Generate Report',
      manageLibrary: 'Manage Library',
    },

    recentActivities: {
      title: 'Recent Activities',
      newStudent: 'New student registered',
      feePayment: 'Fee payment received',
      examCreated: 'New exam created',
      homeworkAssigned: 'Homework assigned',
      leaveApproved: 'Leave approved',
      noticePublished: 'Notice published',
      bookIssued: 'Book issued from library',
      certificateGenerated: 'Certificate generated',
    },

    upcomingEvents: {
      title: 'Upcoming Events',
      parentMeeting: 'Parent Meeting',
      sportsDay: 'Sports Day',
      examWeek: 'Exam Week',
      holiday: 'Holiday',
      workshop: 'Workshop',
    },

    charts: {
      studentGrowth: 'Student Growth',
      feeCollection: 'Fee Collection',
      attendanceTrend: 'Attendance Trend',
      examPerformance: 'Exam Performance',
    },
  },

  // Common
  common: {
    search: 'Search',
    allClasses: 'All Classes',
    allStatus: 'All Status',
    active: 'Active',
    inactive: 'Inactive',
    graduated: 'Graduated',
    transferred: 'Transferred',
    addNew: 'Add New',
    totalStudents: 'Total Students',
    newThisMonth: 'New This Month',
    photo: 'Photo',
    admissionNo: 'Admission No',
    studentName: 'Student Name',
    class: 'Class',
    rollNo: 'Roll No',
    guardian: 'Guardian',
    phone: 'Phone',
    status: 'Status',
    actions: 'Actions',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    close: 'Close',
    confirmDelete: 'Confirm Delete',
    deleteWarning: 'Are you sure you want to delete this record? This action cannot be undone.',
    cancel: 'Cancel',
    email: 'Email',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    bloodGroup: 'Blood Group',
    religion: 'Religion',
    address: 'Address',
    guardianName: 'Guardian Name',
    guardianPhone: 'Guardian Phone',
    guardianEmail: 'Guardian Email',
    relation: 'Relation',
    admissionDate: 'Admission Date',
    category: 'Category',
    house: 'House',
  },

  // Common Actions
  actions: {
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    print: 'Print',
    view: 'View',
    download: 'Download',
    upload: 'Upload',
    submit: 'Submit',
    approve: 'Approve',
    reject: 'Reject',
    reset: 'Reset',
    refresh: 'Refresh',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    confirm: 'Confirm',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    bulkAction: 'Bulk Action',
  },

  // Common Labels
  labels: {
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    date: 'Date',
    time: 'Time',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    completed: 'Completed',
    inProgress: 'In Progress',
    description: 'Description',
    notes: 'Notes',
    category: 'Category',
    type: 'Type',
    amount: 'Amount',
    total: 'Total',
    subtotal: 'Subtotal',
    discount: 'Discount',
    tax: 'Tax',
    from: 'From',
    to: 'To',
    startDate: 'Start Date',
    endDate: 'End Date',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    createdBy: 'Created By',
    updatedBy: 'Updated By',
  },

  // Messages
  messages: {
    success: 'Operation completed successfully',
    error: 'An error occurred, please try again',
    deleteConfirm: 'Are you sure you want to delete?',
    noData: 'No data available',
    loading: 'Loading...',
    saving: 'Saving...',
    processing: 'Processing...',
    uploadSuccess: 'Upload successful',
    uploadError: 'Upload failed',
    invalidData: 'Invalid data',
    requiredField: 'This field is required',
    selectCriteria: 'Select search criteria',
  },

  // Students
  students: {
    title: 'Students',
    studentDetails: 'Student Details',
    manageStudentProfiles: 'Manage Student Profiles',
    totalStudents: 'Total Students',
    activeStudents: 'Active Students',
    graduatedStudents: 'Graduated Students',
    newThisMonth: 'New This Month',
    admissionNo: 'Admission No',
    studentName: 'Student Name',
    class: 'Class',
    section: 'Section',
    rollNo: 'Roll No',
    guardian: 'Guardian',
    phone: 'Phone',
    email: 'Email',
    status: 'Status',
    photo: 'Photo',
    viewDetails: 'View Details',
    studentProfile: 'Student Profile',
    personalInfo: 'Personal Information',
    contactInfo: 'Contact Information',
    guardianInfo: 'Guardian Information',
    academicInfo: 'Academic Information',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    bloodGroup: 'Blood Group',
    religion: 'Religion',
    address: 'Address',
    guardianName: 'Guardian Name',
    guardianPhone: 'Guardian Phone',
    guardianEmail: 'Guardian Email',
    relation: 'Relation',
    admissionDate: 'Admission Date',
    category: 'Category',
    house: 'House',
    deleteConfirm: 'Are you sure you want to delete this student? This action cannot be undone.',
    allClasses: 'All Classes',
    allStatus: 'All Status',
    active: 'Active',
    inactive: 'Inactive',
    graduated: 'Graduated',
    transferred: 'Transferred',
  },

  // Fees
  fees: {
    feeCollection: 'Fee Collection',
    manageFeeCollection: 'Manage fee collection from students',
    totalCollected: 'Total Collected',
    totalPending: 'Total Pending',
    totalOverdue: 'Total Overdue',
    totalDiscount: 'Total Discount',
    yemeniRial: 'Yemeni Rial',
    allClasses: 'All Classes',
    allStatus: 'All Status',
    paid: 'Paid',
    partial: 'Partial',
    pending: 'Pending',
    overdue: 'Overdue',
    feeType: 'Fee Type',
    amount: 'Amount',
    due: 'Due',
    dueDate: 'Due Date',
    recordPayment: 'Record Payment',
    viewReceipt: 'View Receipt',
    feeTypes: 'Fee Types',
    manageFeeTypes: 'Manage academic fee types',
    addFeeType: 'Add Fee Type',
    code: 'Code',
    feeName: 'Fee Name',
    feeGroup: 'Fee Group',
    description: 'Description',
    allGroups: 'All Groups',
    active: 'Active',
    inactive: 'Inactive',
    deleteFeeTypeConfirm: 'Are you sure you want to delete this fee type?',
  },

  // Income
  income: {
    title: 'Income',
    manageIncome: 'Manage income records',
    totalIncome: 'Total Income',
    totalRecords: 'Total Records',
    averageIncome: 'Average Income',
    records: 'Records',
    incomeRecords: 'Income Records',
    addIncome: 'Add Income',
    date: 'Date',
    invoiceNo: 'Invoice No',
    category: 'Category',
    description: 'Description',
    amount: 'Amount',
    paymentMethod: 'Payment Method',
    receivedBy: 'Received By',
    allCategories: 'All Categories',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    deleteConfirm: 'Are you sure you want to delete this income record?',
  },

  // Expenses
  expenses: {
    title: 'Expenses',
    manageExpenses: 'Manage expense records',
    totalExpenses: 'Total Expenses',
    totalRecords: 'Total Records',
    averageExpense: 'Average Expense',
    records: 'Records',
    expenseRecords: 'Expense Records',
    addExpense: 'Add Expense',
    date: 'Date',
    invoiceNo: 'Invoice No',
    category: 'Category',
    description: 'Description',
    amount: 'Amount',
    paymentMethod: 'Payment Method',
    paidTo: 'Paid To',
    vendor: 'Vendor',
    status: 'Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    allCategories: 'All Categories',
    allStatus: 'All Status',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    deleteConfirm: 'Are you sure you want to delete this expense record?',
    approveExpense: 'Approve Expense',
    rejectExpense: 'Reject Expense',
  },

  // Financial Reports
  financialReports: {
    title: 'Financial Reports',
    subtitle: 'Comprehensive financial reports and analytics',
    revenueVsExpenses: 'Revenue vs Expenses',
    profitLoss: 'Profit & Loss',
    feeCollectionRate: 'Fee Collection Rate',
    outstandingFees: 'Outstanding Fees',
    totalRevenue: 'Total Revenue',
    totalExpenses: 'Total Expenses',
    netProfit: 'Net Profit',
    netLoss: 'Net Loss',
    collectionRate: 'Collection Rate',
    outstanding: 'Outstanding',
    monthlyRevenue: 'Monthly Revenue',
    monthlyExpenses: 'Monthly Expenses',
    selectPeriod: 'Select Period',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    thisYear: 'This Year',
    lastYear: 'Last Year',
    custom: 'Custom',
    generateReport: 'Generate Report',
    profitLossStatement: 'Profit & Loss Statement',
    period: 'Period',
    revenue: 'Revenue',
    expenses: 'Expenses',
    profit: 'Profit',
    loss: 'Loss',
  },
};

export default smartSchool;